import document from '../../assets/document-icons/document.svg';
import excel from '../../assets/document-icons/excel.svg';
import folder from '../../assets/document-icons/folder.svg';
import pdf from '../../assets/document-icons/pdf.svg';
import powerpoint from '../../assets/document-icons/powerpoint.svg';
import word from '../../assets/document-icons/word.svg';

export function getFileIconByFileExtension(fileName: string) {
    const extension = fileName.toLowerCase().substring(fileName.lastIndexOf('.') + 1);

    switch (extension) {
        case 'pdf':
            return iconMap['PDF'];
        case 'doc':
        case 'docx':
            return iconMap['Word'];
        case 'xls':
        case 'xlsx':
            return iconMap['Excel'];
        case 'ppt':
        case 'pptx':
            return iconMap['PowerPoint'];
        case 'txt':
        default:
            return iconMap['Text'];
    }
}

const iconMap = {
    Word: <img src={word} className="h-5 w-5" alt="Word icon" />,
    Excel: <img src={excel} alt="Excel icon" className="h-5 w-5" />,
    PowerPoint: <img src={powerpoint} alt="PowerPoint icon" className="h-5 w-5" />,
    PDF: <img src={pdf} alt="PDF icon" className="h-5 w-5" />,
    Others: <img src={document} alt="Document icon" className="h-5 w-5" />,
    Text: <img src={document} alt="Document icon" className="h-5 w-5" />,
};

const defaultIcon = <img src={folder} className="h-5 w-5" alt="Folder icon" />;

export const getIcon = (docType) => {
    return iconMap[docType] || defaultIcon;
};
